<template>
  <div>
    <div v-if="promoCode" class="d-flex">
      <div>
        <span class="badge p-3 text-secondary" style="background-color: rgba(0, 0, 0, 0.08)">
          <i class="fas fa-tag me-2"></i>
          <span class="text-dark">{{ promoCode.code }}</span>
          <a href="#" class="text-secondary ms-2" @click.prevent="removeCode">
            <i class="fas fa-times"></i>
          </a>
        </span>
      </div>
      <div class="ms-auto"></div>
    </div>
    <div v-else>
      <div class="">
        <div v-if="!haveCouponCode">
          <a href="#" class="text-purple fw-semibold small" @click.prevent="haveCouponCode = true">
            {{ 'Have a coupon code?' | translate }}
          </a>
        </div>
        <div v-if="haveCouponCode">
          <div class="d-flex align-items-center">
            <input
              class="form-control form-control-sm me-2"
              type="text"
              :placeholder="$t('Promo Code')"
              @keydown.enter="checkCode"
              v-model="userCode"
              ref="couponInput"
            />
            <button
              class="btn btn-sm"
              :class="{ 'btn-dark': userCode, 'btn-outline-secondary': !userCode }"
              @click="checkCode"
            >
              {{ 'Apply' | translate }}
            </button>
          </div>
          <div v-if="message">
            <small class="text-danger">{{ message }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  data() {
    return {
      userCode: '',
      haveCouponCode: false,
      message: null,
    }
  },
  mounted() {
    this.checkUrlPromoCode()
  },
  methods: {
    checkUrlPromoCode() {
      const url_string = window.location.href
      const url = new URL(url_string)
      let promo_code = url.searchParams.get('promo_code')
      if (promo_code) {
        this.userCode = promo_code
        this.haveCouponCode = true
        this.checkCode()
      } else if (promo_code === '') {
        this.removeCode()
      }
    },
    removeCode() {
      document.cookie = 'promo_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path = /;'
      this.$store.commit('setPromoCode', null)
    },
    promoCodeData() {
      if (this.checkoutType === 'single') {
        return {
          code: this.userCode,
          mode: 'single',
          course_id: this.course.id,
        }
      }
      return {
        code: this.userCode,
        mode: 'subscription',
      }
    },
    checkCode() {
      this.message = null
      this.$api
        .checkPromoCode(this.promoCodeData())
        .then(({ data }) => {
          if (data.success) {
            this.$store.commit('setPromoCode', data.code)
          } else {
            this.message = data.message
          }
        })
        .catch((error) => {
          const message = _.get(error, 'response.data.errors.promo_code[0]', null)
          if (message) {
            this.message = message
            return this.removeCode()
          }
          throw error
        })
    },
  },
  computed: {
    course() {
      return this.$store.state.course
    },
    promoCode() {
      return this.$store.state.promoCode
    },
    checkoutType() {
      return this.$store.state.checkoutType
    },
    student() {
      return this.$store.state.user
    },
  },
}
</script>